import AddCompetition from './AddCompetition.vue';

export * from './types';
export default AddCompetition;



// WEBPACK FOOTER //
// ./src/pages/profile/views/progress/forms/competitionform/index.ts